// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// const PinModal = () => {
//   const [pin, setPin] = useState('');
//   const [confirmPin, setConfirmPin] = useState('');
//   const [showPin, setShowPin] = useState(false);
//   const [showConfirmPin, setShowConfirmPin] = useState(false);
//   const [isOpen, setIsOpen] = useState(true);
//   const [isLoading, setIsLoading] = useState(false); // Loading state
//   const email = localStorage.getItem('email') || '';
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (pin === confirmPin && pin.length === 5) {
//       setIsLoading(true);
//       fetch(`${process.env.REACT_APP_API_URL}oosh/register`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, pin }),
//       })
//         .then(response => response.json())
//         .then(data => {
//           if (data.success) {
//             localStorage.setItem('ooshPin', pin);
//             localStorage.setItem('ooshEmail', email);
//             localStorage.setItem('ooshUniqueNumber', data.uniqueNumber);
//             setIsOpen(false); 
//             navigate('/oosh-dashboard'); 
//           }
//         })
//         .catch(error => console.error('Error:', error))
//         .finally(() => setIsLoading(false)); 
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
//       <div className="bg-white p-6 rounded-lg shadow-lg">
//         <h2 className="text-xl font-bold mb-4">Set oosh PIN</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700">Email: {email}</label>
//           </div>
//           <div className="mb-4 relative">
//             <input
//               type={showPin ? 'text' : 'password'}
//               value={pin}
//               onChange={(e) => setPin(e.target.value)}
//               className="w-full p-2 border rounded"
//               placeholder="Enter 5-digit PIN"
//               maxLength="5"
//               disabled={isLoading}
//             />
//             <button
//               type="button"
//               onClick={() => setShowPin(!showPin)}
//               className="absolute right-2 top-2 text-gray-500"
//               disabled={isLoading}
//             >
//               {showPin ? '🙈' : '👁️'}
//             </button>
//           </div>
//           <div className="mb-4 relative">
//             <input
//               type={showConfirmPin ? 'text' : 'password'}
//               value={confirmPin}
//               onChange={(e) => setConfirmPin(e.target.value)}
//               className="w-full p-2 border rounded"
//               placeholder="Reconfirm PIN"
//               maxLength="5"
//               disabled={isLoading}
//             />
//             <button
//               type="button"
//               onClick={() => setShowConfirmPin(!showConfirmPin)}
//               className="absolute right-2 top-2 text-gray-500"
//               disabled={isLoading}
//             >
//               {showConfirmPin ? '🙈' : '👁️'}
//             </button>
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
//             disabled={pin.length !== 5 || pin !== confirmPin || isLoading}
//           >
//             {isLoading ? (
//               <div className="flex items-center justify-center">
//                 <div className="w-5 h-5 border-2 border-t-2 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
//               </div>
//             ) : (
//               'Submit'
//             )}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default PinModal;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PinModal = () => {
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Start loading to check PIN
  const email = localStorage.getItem('email') || '';
  const navigate = useNavigate();

  useEffect(() => {
    // Check if PIN exists for the email
    const checkPin = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}oosh/check-pin`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        const data = await response.json();
        console.log("your daata is here for you", data)

        if (data.exists) {
          try {
          localStorage.setItem('ooshPin', data.getThePin || ''); 
          localStorage.setItem('ooshEmail', email);
          localStorage.setItem('ooshUniqueNumber', data.jobSeeker.uniqueNumber || '');
          console.log(data.jobSeeker.pin, "your pin is here")
          console.log(data.jobSeeker.uniqueNumber, "your uniqueNumber is here")
          setIsOpen(false);
          navigate('/oosh-dashboard');
          } catch (error) {
            console.log(error)
          }
      
        } else {
        
          setIsLoading(false); 
        }
      } catch (error) {
        console.error('Error checking PIN:', error);
        setIsLoading(false); // Fallback to PIN setup on error
      }
    };

    if (email) {
      checkPin();
    } else {
      setIsLoading(false); // No email, proceed to PIN setup
    }
  }, [email, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pin === confirmPin && pin.length === 5) {
      setIsLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}oosh/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, pin }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            localStorage.setItem('ooshPin', pin);
            localStorage.setItem('ooshEmail', email);
            localStorage.setItem('ooshUniqueNumber', data.uniqueNumber);
            setIsOpen(false);
            navigate('/oosh-dashboard');
          }
        })
        .catch(error => console.error('Error:', error))
        .finally(() => setIsLoading(false));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">Set oosh PIN</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Email: {email}</label>
          </div>
          <div className="mb-4 relative">
            <input
              type={showPin ? 'text' : 'password'}
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter 5-digit PIN"
              maxLength="5"
              disabled={isLoading}
            />
            <button
              type="button"
              onClick={() => setShowPin(!showPin)}
              className="absolute right-2 top-2 text-gray-500"
              disabled={isLoading}
            >
              {showPin ? '🙈' : '👁️'}
            </button>
          </div>
          <div className="mb-4 relative">
            <input
              type={showConfirmPin ? 'text' : 'password'}
              value={confirmPin}
              onChange={(e) => setConfirmPin(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Reconfirm PIN"
              maxLength="5"
              disabled={isLoading}
            />
            <button
              type="button"
              onClick={() => setShowConfirmPin(!showConfirmPin)}
              className="absolute right-2 top-2 text-gray-500"
              disabled={isLoading}
            >
              {showConfirmPin ? '🙈' : '👁️'}
            </button>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
            disabled={pin.length !== 5 || pin !== confirmPin || isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-5 h-5 border-2 border-t-2 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
              </div>
            ) : (
              'Submit'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PinModal;